import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Cookies from 'js-cookie';
import { apiFetch } from '../../hooks/apiFetch';
import SuccessErrorMsg from '../../utilities/SuccessErrorMsg';
import { useNavigate } from 'react-router-dom';
import AdvancedServiceMsg from "./components/AdvancedServiceMsg";
import serviceSampleImg from "../../assets/defaults/Profile-Sample0.jpg";
import { useLangUrl } from '../../utilities/useLangUrl';

export default function AdvanceServiceDetails() {
    const { AdServiceId } = useParams();
    const { t, i18n } = useTranslation();
    const [, setLoading] = useState(false);
    const navigate = useNavigate();
    const [selectedService, setSelectedService] = useState("");
    const [error, setError] = useState(null);
    const serviceToShow = selectedService?.data;
    const { handleSubmit } = useForm();
    const langUrl = useLangUrl();


    useEffect(() => {
        async function fetchAdvServicesDetails() {
            try {
                const data = await fetch(`${process.env.REACT_APP_MASAR_API_URL}/services/${AdServiceId}`, {
                    method: "GET",
                    headers: {
                        "accept": "*/*"
                    },
                    body: JSON.stringify()
                });
                const responseData = await data.json();
                setSelectedService(responseData);
            } catch (err) {
                setError(t("errorGetData"));
            }
        }

        fetchAdvServicesDetails();
    }, [t, AdServiceId]);

    // console.log(advanceServiceData);

    function getQuot(e) {
        // e.preventDefault();
        if (!Cookies.get('token')) {
            return (
                i18n.language === "ar" ?
                    toast.warn(<p className="p-0 m-0">تأكد من  <Link to={`${langUrl}/logIn`}>تسجيل الدخول</Link> لإرسال الطلب</p>) :
                    toast.warn(<p className="p-0 m-0">Make sure to <Link to={`${langUrl}/logIn`}>Log in</Link> to get qout</p>)
            )
        } else {
            e.target.setAttribute("data-bs-toggle", "modal");
            e.target.setAttribute("data-bs-target", "#AdvanceServiceMsg");
        }
    }
    async function onSubmit(data) {
        setLoading(true);

        try {
            const response = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/carts/${AdServiceId}`, {
                method: "POST",

                body: JSON.stringify(data)
            });

            // Redirect to another page after successful submission
            if (response.isSuccess) {
                toast.success(t("OrderInCart"));
                setTimeout(() => {
                    // window.location.reload();
                    navigate('/advancedServices');
                }, 3000);
            } else {
                toast.error(t("errorTryAgain"), response.message);
            }
        } catch (error) {
            console.error("Error during form submission: ", error); // Debug: Check error
            switch (error.response.status) {
                case 403:
                    i18n.language === "ar" ?
                        toast.error(<p className="p-0 m-0">تأكد من  <Link to={`${langUrl}/logIn`}>تسجيل الدخول</Link></p>) :
                        toast.error(<p className="p-0 m-0">Make sure to <Link to={`${langUrl}/logIn`}>Log in</Link></p>);
                    break;
                case 500:
                    i18n.language === "ar" ?
                        toast.error(<p className="p-0 m-0">تأكد من  <Link to={`${langUrl}/logIn`}>تسجيل الدخول</Link> أو تواصل مع الدعم</p>) :
                        toast.error(<p className="p-0 m-0">Make sure to <Link to={`${langUrl}/logIn`}>Log in</Link> or contact support</p>);
                    break;
                case 400:
                    toast.warn(t("errorCorrectData"));
                    break;
                default:
                    toast.warn(t("errorGetSupport"));
            }

        } finally {
            setLoading(false);

        }
    }


    if (error) {
        return <div className="text-center my-4 text-danger">{error}</div>;
    }

    if (!selectedService) {
        return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    }
    return (
        <div className="container mt-4">
            <div className="d-flex flex-column-reverse flex-md-row align-items-center justify-content-center">
                {/* Offer Details */}
                <div className="col-12 col-md-7 text-center text-md-start">
                    <h2 className="fw-bold mb-4">
                        {/* {serviceToShow.name} */}
                        {i18n.language === "ar" ? serviceToShow.nameAr : serviceToShow.name}
                    </h2>
                    {serviceToShow.description &&
                        <div className="mb-3">
                            <h6 className="text-decoration-underline">{t("Details")}</h6>
                            <div className="ms-3">
                                {/* <p>{serviceToShow.description}</p> */}
                                <p>{i18n.language === "ar" ? serviceToShow.descriptionAr : serviceToShow.description}</p>
                            </div>
                        </div>
                    }
                    <button className="btn btn-masar btn-dark-orange mt-2"
                        onClick={getQuot}
                    >
                        {t("GetQoutation")}
                    </button>
                    <SuccessErrorMsg
                        ToastContainer={ToastContainer} />
                </div>
                {/* Advanced Service Image */}
                <div className="col-12 col-md-5 mb-4 mb-md-0 d-flex justify-content-center">
                    <div className="background-white rounded-3 shadow-sm p-3">
                        <img className="w-100 rounded-3 object-fit-contain"
                            crossOrigin="anonymous"
                            src={serviceToShow.thumbnail ? serviceToShow.thumbnail : serviceSampleImg}
                            alt={`AdvService_${serviceToShow.id}`}
                        />
                    </div>
                </div>
                <AdvancedServiceMsg
                    serviceToShow={serviceToShow}
                    t={t}
                    i18n={i18n}
                    handleSubmit={handleSubmit}
                    onSubmit={onSubmit}
                />
            </div>
        </div>
    );

};